// font properties
export const FontFamilyBase =
    'Helvetica Neue, -apple-system, BlinkMacSystemFont, Arial, Roboto, Ubuntu, system-ui, sans-serif';
export const FontSizeSmall = '12';
export const FontSizeBody = '14';
export const FontSizeBase = '16';
export const FontSizeH6 = '18';
export const FontSizeH5 = '20';
export const FontSizeH4 = '23';
export const FontSizeH3 = '26';
export const FontSizeH2 = '29';
export const FontSizeH1 = '32';
export const FontSizeXlarge = '42';
export const FontSizeXxlarge = '48';

// COMMON

export const COMMON_BLACK = '#000000';
export const COMMON_WHITE = '#ffffff';

// PRIMARY

export const LM_PRIMARY_MAIN = '#3747D3';
export const DM_PRIMARY_MAIN = '#DCDCFF';

export const LM_PRIMARY_LIGHT = '#3E4FED';
export const DM_PRIMARY_LIGHT = '#B8B8FC';

export const LM_PRIMARY_DARK = '#0018B3';
export const DM_PRIMARY_DARK = '#E4F2FF';

export const LM_PRIMARY_CONTRAST_TEXT = '#ffffff';
export const DM_PRIMARY_CONTRAST_TEXT = '#000e81';

export const LM_PRIMARY_HOVER = '#3747D30A';
export const DM_PRIMARY_HOVER = '#DCDCFF0A';

export const LM_PRIMARY_FOCUS = '#3747D31F';
export const DM_PRIMARY_FOCUS = '#DCDCFF1F';

export const LM_PRIMARY_FOCUS_VISIBLE = '#3747D34D';
export const DM_PRIMARY_FOCUS_VISIBLE = '#DCDCFF4D';

export const LM_PRIMARY_SELECTED = '#3747D314';
export const DM_PRIMARY_SELECTED = '#DCDCFF14';

// SECONDARY

export const LM_SECONDARY_MAIN = '#64298B';
export const DM_SECONDARY_MAIN = '#F0B9FF';

export const LM_SECONDARY_LIGHT = '#7730A6';
export const DM_SECONDARY_LIGHT = '#C896FF';

export const LM_SECONDARY_DARK = '#5C0976';
export const DM_SECONDARY_DARK = '#D8CAFF';

export const LM_SECONDARY_CONTRAST_TEXT = '#ffffff';
export const DM_SECONDARY_CONTRAST_TEXT = '#3e0062';

export const LM_SECONDARY_HOVER = '#64298B0A';
export const DM_SECONDARY_HOVER = '#F0B9FF0A';

export const LM_SECONDARY_FOCUS = '#64298B1F';
export const DM_SECONDARY_FOCUS = '#F0B9FF1F';

export const LM_SECONDARY_FOCUS_VISIBLE = '#64298B4D';
export const DM_SECONDARY_FOCUS_VISIBLE = '#F0B9FF4D';

export const LM_SECONDARY_SELECTED = '#64298B14';
export const DM_SECONDARY_SELECTED = '#F0B9FF14';

// ERROR

export const LM_ERROR_MAIN = '#B31430';
export const DM_ERROR_MAIN = '#FFAAA5';

export const LM_ERROR_LIGHT = '#CC1638';
export const DM_ERROR_LIGHT = '#DC8CA5';

export const LM_ERROR_DARK = '#7D001B';
export const DM_ERROR_DARK = '#FFD8E3';

export const LM_ERROR_CONTRAST_TEXT = '#ffffff';
export const DM_ERROR_CONTRAST_TEXT = '#540005';

export const LM_ERROR_HOVER = '#B314300A';
export const DM_ERROR_HOVER = '#FFAAA50A';

export const LM_ERROR_FOCUS = '#B314301F';
export const DM_ERROR_FOCUS = '#FFAAA51F';

export const LM_ERROR_FOCUS_VISIBLE = '#B314304D';
export const DM_ERROR_FOCUS_VISIBLE = '#FFAAA54D';

export const LM_ERROR_SELECTED = '#B3143014';
export const DM_ERROR_SELECTED = '#FFAAA514';

// WARNING

export const LM_WARNING_MAIN = '#9B2C00';
export const DM_WARNING_MAIN = '#FFC3A0';

export const LM_WARNING_LIGHT = '#B53300';
export const DM_WARNING_LIGHT = '#E6B091';

export const LM_WARNING_DARK = '#803300';
export const DM_WARNING_DARK = '#FFE9D7';

export const LM_WARNING_CONTRAST_TEXT = '#ffffff';
export const DM_WARNING_CONTRAST_TEXT = '#542200';

export const LM_WARNING_HOVER = '#9B2C000A';
export const DM_WARNING_HOVER = '#FFC3A00A';

export const LM_WARNING_FOCUS = '#9B2C001F';
export const DM_WARNING_FOCUS = '#FFC3A01F';

export const LM_WARNING_FOCUS_VISIBLE = '#9B2C004D';
export const DM_WARNING_FOCUS_VISIBLE = '#FFC3A04D';

export const LM_WARNING_SELECTED = '#9B2C0014';
export const DM_WARNING_SELECTED = '#FFC3A014';

// INFO

export const LM_INFO_MAIN = '#006096';
export const DM_INFO_MAIN = '#8CAFFF';

export const LM_INFO_LIGHT = '#006FB0';
export const DM_INFO_LIGHT = '#7A98DE';

export const LM_INFO_DARK = '#005473';
export const DM_INFO_DARK = '#CFE5FF';

export const LM_INFO_CONTRAST_TEXT = '#ffffff';
export const DM_INFO_CONTRAST_TEXT = '#003353';

export const LM_INFO_HOVER = '#0060960A';
export const DM_INFO_HOVER = '#8CAFFF0A';

export const LM_INFO_FOCUS = '#0060961F';
export const DM_INFO_FOCUS = '#8CAFFF1F';

export const LM_INFO_FOCUS_VISIBLE = '#0060964D';
export const DM_INFO_FOCUS_VISIBLE = '#8CAFFF4D';

export const LM_INFO_SELECTED = '#00609614';
export const DM_INFO_SELECTED = '#8CAFFF14';

// SUCCESS

export const LM_SUCCESS_MAIN = '#1E6020';
export const DM_SUCCESS_MAIN = '#7DC873';

export const LM_SUCCESS_LIGHT = '#267A29';
export const DM_SUCCESS_LIGHT = '#6CAD63';

export const LM_SUCCESS_DARK = '#01502B';
export const DM_SUCCESS_DARK = '#BAFFC0';

export const LM_SUCCESS_CONTRAST_TEXT = '#ffffff';
export const DM_SUCCESS_CONTRAST_TEXT = '#003909';

export const LM_SUCCESS_HOVER = '#1E60200A';
export const DM_SUCCESS_HOVER = '#7DC8730A';

export const LM_SUCCESS_FOCUS = '#1E60201F';
export const DM_SUCCESS_FOCUS = '#7DC8731F';

export const LM_SUCCESS_FOCUS_VISIBLE = '#1E60204D';
export const DM_SUCCESS_FOCUS_VISIBLE = '#7DC8734D';

export const LM_SUCCESS_SELECTED = '#1E602014';
export const DM_SUCCESS_SELECTED = '#7DC87314';

// NEUTRAL

export const LM_NEUTRAL_TWILIGHT = '#EEEEEE';
export const DM_NEUTRAL_TWILIGHT = '#424242';

export const LM_NEUTRAL_LIGHT = '#FAFAFA';
export const DM_NEUTRAL_LIGHT = '#212121';

export const LM_NEUTRAL_DARK = '#E0E0E0';
export const DM_NEUTRAL_DARK = '#616161';

export const LM_NEUTRAL_CONTRAST_TEXT = '#111111';
export const DM_NEUTRAL_CONTRAST_TEXT = '#ffffff';

// TEXT

export const LM_TEXT_PRIMARY = '#111111';
export const DM_TEXT_PRIMARY = '#ffffff';

export const LM_TEXT_SECONDARY = '#333738';
export const DM_TEXT_SECONDARY = '#dadddd';

export const LM_TEXT_DISABLED = '#5c5e5e';
export const DM_TEXT_DISABLED = '#909191';

// DIVIDER

export const LM_DIVIDER = '#E7E7E7';
export const DM_DIVIDER = '#525252';

// BACKGROUND

export const LM_BACKGROUND_DEFAULT = '#f2f2f2';
export const DM_BACKGROUND_DEFAULT = '#242626';

export const LM_BACKGROUND_PAPER = '#ffffff';
export const DM_BACKGROUND_PAPER = '#1A1C1C';

export const LM_BACKGROUND_PAPER_LINEAR_GRADIENT = '#FFFFFF1F';
export const DM_BACKGROUND_PAPER_LINEAR_GRADIENT = '#1A1C1C1F';

export const LM_BACKGROUND_OVERLAY = '#00000080';
export const DM_BACKGROUND_OVERLAY = '#00000080';

// ACTION

export const LM_ACTION_ACTIVE = '#0000008A';
export const DM_ACTION_ACTIVE = '#FFFFFF8A';

export const LM_ACTION_HOVER = '#0000000A';
export const DM_ACTION_HOVER = '#FFFFFF0A';

export const LM_ACTION_FOCUS = '#0000001F';
export const DM_ACTION_FOCUS = '#FFFFFF1F';

export const LM_ACTION_FOCUS_VISIBLE = '#0000004D';
export const DM_ACTION_FOCUS_VISIBLE = '#FFFFFF4D';

export const LM_ACTION_SELECTED = '#00000014';
export const DM_ACTION_SELECTED = '#FFFFFF14';

export const LM_ACTION_DISABLED = '#00000042';
export const DM_ACTION_DISABLED = '#FFFFFF42';

export const LM_ACTION_DISABLED_BACKGROUND = '#0000001F';
export const DM_ACTION_DISABLED_BACKGROUND = '#FFFFFF1F';

export const LM_ACTION_ACTIVATED = '#0000001F';
export const DM_ACTION_ACTIVATED = '#FFFFFF1F';

export const LM_ACTION_DRAGGED = '#0000001F';
export const DM_ACTION_DRAGGED = '#FFFFFF1F';

// BRAND

export const BRAND_MAIN = '#EA0049';
export const BRAND_CONTRAST_TEXT = '#ffffff';
